import { AppContext, BookingData, Recurrence } from "../../../../../AppDataProvider/AppDataProvider";
import { marginBottom, marginRight, typography } from "../../../../../common/styles";
import React, { useContext } from "react";
import { applyOpacity } from "../../../../../common/styles/utils";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getRecurringDescription } from "../../../../../utils";
import { PartRequired } from "../../../../../utils/types";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
export type RecurringSlotInfoProps = {
  recurrence: Recurrence;
  startDate: string;
};
export function RecurringSlotInfo(props: RecurringSlotInfoProps): React.ReactElement {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    appData
  } = useContext(AppContext);
  type RecurringSlotInfoBookingData = PartRequired<BookingData, "service" | "timezone">;
  const {
    service
  } = appData.bookingData as RecurringSlotInfoBookingData;
  const {
    recurrence,
    startDate
  } = props;
  const recurringDescription = getRecurringDescription({
    locale: i18n.language,
    recurrence,
    service,
    startDate,
    t
  });
  return <Container data-sentry-element="Container" data-sentry-component="RecurringSlotInfo" data-sentry-source-file="RecurringSlotInfo.tsx">
      <Icon icon={faSyncAlt} data-sentry-element="Icon" data-sentry-source-file="RecurringSlotInfo.tsx" />
      <Description data-sentry-element="Description" data-sentry-source-file="RecurringSlotInfo.tsx">{recurringDescription}</Description>
    </Container>;
}
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  ${marginBottom.m}
`;
const Icon = styled(FontAwesomeIcon)`
  ${marginRight.s}
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.4, false)}
`;
const Description = styled.div`
  ${typography.bodyBold}
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.6, false)};
`;